import { BinInfo } from "../staticInfo/state"

export interface CleaningState{
    cleaningDateList:CleaningDateList[]|[]
    cleaningRouteList:CleaningRouteList[]|[]
    cleaningDetailRouteList:CleaningDetailRouteList[]|[]
    cleaningDetailImageList:CleaningDetailImageList[]|[]
    selectedCleaningDetail:CleaningDetailRouteList  
    binInfo?:BinInfo
    clickDate:string
    cleaningImageType:CleanImageType[]|[]
}

export interface CleanImageType{
    cleaning_image_type_id:number,
    image_type_name:string
    image_type_name_en:string
}

export interface CleaningDateList{
    weekday:string
    route_cleaning_id:number,
    date:string
}

export interface CleaningRouteList{
    route_cleaning_id: number,
    route_name: string
}

export interface CleaningDetailRouteList{
    cleaning_id: number,
    bin_id:number,
    bin_full_name: string
    sequence:number
    time_start: string
    time_end: string
    attendance_date: moment.Moment|null|string,
    attendance_place:string,
    update_date: moment.Moment|null|string,
    cleaning_detail_route_id:string
    people_counter_number:string
    create_date:string
    contract_id?:number
    value?:string
}

export interface CleaningDetailImageList{
    cleaning_image_id: number
    image: string
    image_thumb:string
    image_type_id:number,
    image_type_name:string
}

export const cleaningState:CleaningState ={
    cleaningDateList:[],
    cleaningRouteList:[],
    cleaningDetailRouteList:[],
    cleaningDetailImageList:[],
    clickDate:'',
    cleaningImageType:[],
    selectedCleaningDetail:{
        bin_id:0,
        cleaning_id: 0,
        bin_full_name: '',
        sequence:0,
        time_start: '',
        time_end: '',
        attendance_date: null,
        update_date: null,
        cleaning_detail_route_id:'',
        people_counter_number:'',
        attendance_place:'',
        value:'',
        create_date:''
        
       
    }
}

